"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _lib = require("../../lib");
var _ChipItem = require("../../lib/ChipItem");
var _FormField = require("../../lib/FormField");
var _IconButton = require("../../lib/IconButton");
var _Text = require("../../lib/Text");
var _PasswordField = require("./PasswordField.styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PasswordField = function PasswordField(_ref) {
  var _ref$passwordLabel = _ref.passwordLabel,
    passwordLabel = _ref$passwordLabel === void 0 ? 'Password' : _ref$passwordLabel,
    _ref$confirmPasswordL = _ref.confirmPasswordLabel,
    confirmPasswordLabel = _ref$confirmPasswordL === void 0 ? 'Confirm Password' : _ref$confirmPasswordL,
    onChange = _ref.onChange,
    required = _ref.required;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isPasswordVisible = _useState2[0],
    setPasswordVisibility = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isConfirmPasswordVisible = _useState4[0],
    setConfirmPasswordVisibility = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    password = _useState6[0],
    setPassword = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    confirmPassword = _useState8[0],
    setConfirmPassword = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    hasMinimumAmount = _useState10[0],
    setHasMinimumAmount = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    hasUppercase = _useState12[0],
    setHasUppercase = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    hasLowercase = _useState14[0],
    setHasLowercase = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    hasSpecialCharacter = _useState16[0],
    setHasSpecialCharacter = _useState16[1];
  var handleValidation = function handleValidation(event) {
    var passwordInputValue = event.target.value.trim();
    var uppercaseRegExp = /(?=.*?[A-Z])/;
    var lowercaseRegExp = /(?=.*?[a-z])/;
    var specialCharRegExp = /(?=.*?[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~])/;
    var minLengthRegExp = /.{6,}/;
    var uppercasePassword = uppercaseRegExp.test(passwordInputValue);
    var lowercasePassword = lowercaseRegExp.test(passwordInputValue);
    var specialCharPassword = specialCharRegExp.test(passwordInputValue);
    var minLengthPassword = minLengthRegExp.test(passwordInputValue);
    setHasUppercase(uppercasePassword);
    setHasLowercase(lowercasePassword);
    setHasSpecialCharacter(specialCharPassword);
    setHasMinimumAmount(minLengthPassword);
    if (onChange) {
      onChange(passwordInputValue, uppercasePassword && lowercasePassword && specialCharPassword && minLengthPassword && passwordInputValue === confirmPassword);
    }
  };
  var handleConfirmValidation = function handleConfirmValidation(event) {
    var passwordInputValue = event.target.value.trim();
    if (onChange) {
      onChange(password, hasUppercase && hasLowercase && hasSpecialCharacter && hasMinimumAmount && password === passwordInputValue);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_PasswordField.FieldWithIcon, null, /*#__PURE__*/_react["default"].createElement(_FormField.FormField, {
    label: "".concat(passwordLabel).concat(required ? '*' : ''),
    type: isPasswordVisible ? 'text' : 'password',
    value: password,
    onChange: function onChange(val) {
      setPassword(val);
    },
    onKeyUp: handleValidation
  }), /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
    dense: true,
    format: "round",
    style: {
      marginTop: '4px',
      marginLeft: '4px'
    },
    icon: isPasswordVisible ? 'visibility-on' : 'visibility-off',
    color: _lib.DefaultTheme.color.white,
    containerColor: _lib.DefaultTheme.color.primary["default"],
    colored: true,
    onClick: function onClick() {
      return setPasswordVisibility(!isPasswordVisible);
    }
  })), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    type: "small",
    style: {
      margin: '4px 0'
    }
  }, "The password must have at least:"), /*#__PURE__*/_react["default"].createElement(_PasswordField.ChipsContainer, null, /*#__PURE__*/_react["default"].createElement(_ChipItem.ChipItem, {
    themeColor: hasMinimumAmount ? _lib.DefaultTheme.color.success : null,
    label: /*#__PURE__*/_react["default"].createElement(_Text.Text, {
      type: "small",
      color: hasMinimumAmount ? _lib.DefaultTheme.color.success : null
    }, "More than 6 characters")
  }), /*#__PURE__*/_react["default"].createElement(_ChipItem.ChipItem, {
    themeColor: hasUppercase ? _lib.DefaultTheme.color.success : null,
    label: /*#__PURE__*/_react["default"].createElement(_Text.Text, {
      type: "small",
      color: hasUppercase ? _lib.DefaultTheme.color.success : null
    }, "One uppercase character")
  }), /*#__PURE__*/_react["default"].createElement(_ChipItem.ChipItem, {
    themeColor: hasLowercase ? _lib.DefaultTheme.color.success : null,
    label: /*#__PURE__*/_react["default"].createElement(_Text.Text, {
      type: "small",
      color: hasLowercase ? _lib.DefaultTheme.color.success : null
    }, "One lowercase character")
  }), /*#__PURE__*/_react["default"].createElement(_ChipItem.ChipItem, {
    themeColor: hasSpecialCharacter ? _lib.DefaultTheme.color.success : null,
    label: /*#__PURE__*/_react["default"].createElement(_Text.Text, {
      type: "small",
      color: hasSpecialCharacter ? _lib.DefaultTheme.color.success : null
    }, "One special character")
  })), /*#__PURE__*/_react["default"].createElement(_PasswordField.FieldWithIcon, {
    style: {
      marginTop: '8px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_FormField.FormField, {
    label: "".concat(confirmPasswordLabel).concat(required ? '*' : ''),
    type: isConfirmPasswordVisible ? 'text' : 'password',
    value: confirmPassword,
    onChange: function onChange(val) {
      setConfirmPassword(val);
    },
    onKeyUp: handleConfirmValidation
  }), /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
    dense: true,
    format: "round",
    style: {
      marginTop: '4px',
      marginLeft: '4px'
    },
    icon: isConfirmPasswordVisible ? 'visibility-on' : 'visibility-off',
    color: _lib.DefaultTheme.color.white,
    containerColor: _lib.DefaultTheme.color.primary["default"],
    colored: true,
    onClick: function onClick() {
      return setConfirmPasswordVisibility(!isConfirmPasswordVisible);
    }
  })));
};
var _default = exports["default"] = PasswordField;